import request from '@/utils/request'

// REQ-2026-574277 AI 回复审核 —— 管理端接口
// 后端 WebConst.ModulePath.IM + "/aiReview"
const apiPath = '/im/aiReview'

const aiReviewApi = {
  /** 分页列表（默认待审核） */
  fetchList(data) {
    return request.post(`${apiPath}/list`, data)
  },
  /** 待审核条数，菜单/页签角标 */
  pendingCount() {
    return request.get(`${apiPath}/pendingCount`)
  },
  /** 最小统计：{ today: {...}, last7Days: {...} }（§10.4） */
  stats() {
    return request.get(`${apiPath}/stats`)
  },
  /** 详情：该会话最近 20 条上下文 */
  context(id) {
    return request.get(`${apiPath}/context/${id}`)
  },
  /** 忽略 */
  ignore(id) {
    return request.post(`${apiPath}/ignore/${id}`)
  },
  /**
   * 发送 / 编辑后发送 / 人工直接回复
   *
   * ⚠️ action 三种取值必须与后端一致：SEND / EDIT_SEND / MANUAL_REPLY。
   * 幂等由 app-server 按 reviewId+action 判，前端重复点不会重复发给客户，
   * 但仍要把按钮置灰——让用户看到"点过了"，而不是靠后端悄悄吞掉。
   */
  send(data) {
    return request.post(`${apiPath}/send`, data)
  }
}

export default aiReviewApi
